
import './App.css';

import React from 'react';
import GitHubActivityReport from './components/GitHubActivityReport';

function App() {
  return (
    <div className="container mx-auto p-4">
      <GitHubActivityReport />
    </div>
  );
}

export default App;
